const imageSliderInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-image-slider .swiper")] : Array.from(
        document.querySelectorAll(".bn-image-slider .swiper")
    );

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                        prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 40
                        }
                    }
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        imageSliderInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/image-slider', imageSliderInit);
});